export const HOME_PATH = "/";
export const PRODUCT_PATH = "/products";
export const PRODUCT_DETAIL_PATH = "/products";
export const FACILITIES_PATH = "/facilities";
export const NEWS_PATH = "/news";
export const ABOUT_US_PATH = "/about-us";
export const CAREER_PATH = "/career";
export const DISCUSS_PATH = "/discuss";
